export const TEXT_US_NUMBER = '+17814511638';
export const TEXT_US_CONTENT = 'Hi! I have a question about StyleSeat.';
export const SMS_SHORT_CODE = '789537';
